<div #dateSelector class="dateSelector">
	<sim-chevron-overflow #overflowHandler>
		@for (month of daysByMonth() | keyvalue; track month.key) {
			<div #monthElement class="monthWrapper">
				<label>{{ month.key | date: "MMM yyyy" :'': translate.currentLang }}</label>
				@for (day of month.value; track day.date) {
					@let isEmpty = !day.sessions?.length;
					<div
						[matTooltip]="isEmpty && !allowSelectEmptyDay() ? (T.SHARED_EVENT_CONTAINER_NO_SESSION_FOUND_DAY | translate) : ''"
					>
						<div
							#dayBtn
							[class.selected]="isSameDay($selectedDay?.getValue()?.date, day.date)"
							[class.disabled]="isEmpty && !allowSelectEmptyDay()"
							[matBadge]="day.sessions?.length"
							[matBadgeHidden]="isEmpty"
							matBadgeSize="small"
							class="dayButton"
							role="button"
							(click)="$selectedDay?.next(day)"
						>
							<span>
								{{ day.date | date: "EE" :'': translate.currentLang }}
							</span>
							<span>
								{{ day.date | date: "dd" :'': translate.currentLang }}
							</span>
						</div>
					</div>
				}
			</div>
		}
	</sim-chevron-overflow>
</div>
